import React, { useEffect } from "react";

export const DeckNavigation = ({ count, active, onJump, onComplete, variant = "dots" }) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Don't trigger if user is typing in an input or textarea
      if (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA") {
        return;
      }

      if (e.key === "Enter" || e.key === "ArrowRight" || e.key === "ArrowDown" || e.key === " ") {
        e.preventDefault();
        if (active < count - 1) {
          onJump(active + 1);
        } else if (onComplete) {
          onComplete();
        }
      } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
        e.preventDefault();
        if (active > 0) onJump(active - 1);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [active, count, onJump, onComplete]);

  return (
    <div
      className={`fixed top-1/2 -translate-y-1/2 z-[100] flex flex-col ${
        variant === "bars" ? "right-[76px] items-end gap-2 hidden lg:flex" : "right-6 gap-3 hidden md:flex"
      }`}
      data-testid="deck-navigation"
    >
      {variant === "bars" && (
        <div className="font-mono font-black text-sm tracking-[0.16em] text-[#d8b62e] mb-2">
          {String(active + 1).padStart(2, "0")}
        </div>
      )}

      {Array.from({ length: count }).map((_, i) => (
        <button
          key={i}
          onClick={() => onJump(i)}
          data-testid={`slide-nav-dot-${i}`}
          aria-label={`Go to slide ${i + 1}`}
          className={`group flex items-center bg-transparent border-0 cursor-pointer p-0 ${
            variant === "bars" ? "justify-end w-[54px] h-[18px]" : "gap-3"
          }`}
        >
          {variant === "bars" ? (
            <span
              className={`block h-[2px] transition-all duration-200 ${
                active === i ? "w-[30px] bg-[#d8b62e]" : "w-[14px] bg-white/30 group-hover:w-[22px] group-hover:bg-white/60"
              }`}
            />
          ) : (
            <>
              <span
                className={`block transition-all duration-500 ${
                  active === i
                    ? "w-6 h-[2px] bg-[var(--ph-accent)]"
                    : "w-3 h-[2px] bg-white/20 group-hover:bg-white/50"
                }`}
              />
              <span
                className={`font-mono text-[10px] tracking-widest transition-opacity duration-300 ${
                  active === i ? "opacity-100 text-[var(--ph-accent)]" : "opacity-0"
                }`}
              >
                {String(i + 1).padStart(2, "0")}
              </span>
            </>
          )}
        </button>
      ))}
    </div>
  );
};

